import Vuex from 'vuex';
import ClipSlider from './components/ClipSlider.vue';
Vue.component('book-table-of-content-section', require('./components/BookTableOfContentSection.vue').default);
Vue.component('clip-slider', require('./components/ClipSlider.vue').default);
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        savedClipList: [],
        sections: {},
        sectionsWiseClips: {},
        is_draggable: false,
        is_loading:true,
    },
    getters: {
        getCurrentSectionClips: (state) => (id) => {
            var clip_list = state.sectionsWiseClips[id];
            var section_clips = {};
            $.each(clip_list, function (index, val) {
                if (val) {
                    section_clips[val.pivot.position] = val;
                }
            });
            return section_clips;
        }
    },
    mutations: {
        getClipList(state, data) {
            let is_first_time = data.is_first_time;
            data = data.data;
            let sections = [], clip_list = {};
            let is_draggable = state.is_draggable;

            if (data.hasOwnProperty('clip_list')) {
                clip_list = data.clip_list;
                is_draggable = 'yes';
            } else {
                clip_list = data;
            }
            let list = clip_list;

            if(jQuery.type( list ) === 'object') {
                var array = $.map(list, function(value, index) {
                    return [value];
                });
                list = clip_list = array;
            }
            if ( typeof(is_first_time) === 'undefined' && is_draggable === false) {
                list = clip_list.filter(function (clip) {
                    var new_clip = '';
                    if (jQuery.type(state.sectionsWiseClips[`${clip.pivot.section_id}`]) === 'undefined') {
                        //if there is no clips in the current section
                        new_clip = 'yes';
                    } else if (jQuery.type(state.sectionsWiseClips[`${clip.pivot.section_id}`][`${clip.id}`]) === 'undefined') {
                        // if current section not having the current clip
                        new_clip = 'yes';
                    }

                    if (new_clip !== '') {
                        clip['status'] = "test";
                        clip['message'] = "added successfully!";
                    } else {
                        delete clip['message'];
                        delete clip['status'];
                    }
                    return clip;
                });
            }
            // if(is_draggable === '') {
            state.sectionsWiseClips = {};
            list.filter(function (clip) {
                var section_id = clip.pivot.section_id;
                if (!(section_id in sections)) {
                    sections[section_id] = 1;
                    state.sectionsWiseClips[`${section_id}`] = {};
                } else {
                    sections[section_id] += 1;
                }
                state.sectionsWiseClips[`${section_id}`][`${clip.id}`] = clip;
            });
            state.sections = sections;
            // }
            state.savedClipList = list;
            state.is_loading = false;
        },
        isDraggable(state, data) {
            // console.log('isDraggable');
            var is_draggable = data.is_draggable;
            state.is_draggable = is_draggable;
        },
        isLoading(state, data) {
            // console.log('isDraggable');
            state.is_loading = data;
        },
    }
})

var clipListAndInsertSectionVue = new Vue({
    el: "#clipListAndInsertSection",
    store,
    components: { ClipSlider },
    data: {
    },
    computed: {
        savedClipList: function () {
            var result = store.state.savedClipList;
            return result;
        }
    },
    methods: {
        setData(book_id, is_first_time='') {
            axios.post(route('user.book.getClipList', {id:book_id}))
                .then(({ data }) => {
                    store.commit("getClipList", { data: data, is_first_time: is_first_time });
                });
        },
        refreshData(book_id) {
            this.setData(book_id);
        },
    },
});